import { SortColumn } from "react-data-grid";

import { ResultData } from "../../../../../service/Shared";
import {
  CursorDataGrid,
  DataGridColumnDefinition,
  DataGridCursorDataLoadEventHandler,
  ExpandableCard,
} from "../../../../../widget";

export interface DashboardTableCardProps {
  data?: ResultData[];
  columns: DataGridColumnDefinition[];
  title: string;
  expandRoute?: string;
  height?: number;
  sortable?: boolean;
  isLoading: boolean;
  refresh?: boolean;
  defaultSortingCriteria?: SortColumn[];
  onChange?: DataGridCursorDataLoadEventHandler;
}

export const DashboardTableCard = ({
  data,
  columns,
  title,
  expandRoute,
  height,
  sortable = false,
  isLoading,
  refresh,
  defaultSortingCriteria,
  onChange,
}: DashboardTableCardProps): JSX.Element => {
  return (
    <ExpandableCard height={height} title={title} targetRoute={expandRoute}>
      <CursorDataGrid
        data={data || []}
        onChange={onChange}
        columns={columns}
        clientSide={onChange === undefined}
        pageable={false}
        sortable={sortable}
        refresh={refresh}
        pagination={{ totalCount: data?.length || 0 }}
        dataIsLoading={isLoading}
        defaultSortingCriteria={defaultSortingCriteria}
        noDataMessage="No projects to display"
      />
    </ExpandableCard>
  );
};
